import React, { useEffect, useRef, useState } from "react";
import styles from "./TableOfContents.module.css";

export default function TableOfContents({ headings }) {
    const [activeId, setActiveId] = useState("");
    const observerRef = useRef(null);

    useEffect(() => {
        if (headings.length === 0) return;

        observerRef.current?.disconnect();

        const observer = new IntersectionObserver(
            (entries) => {
                // Pega o primeiro heading visível de cima para baixo
                const visible = entries
                    .filter((e) => e.isIntersecting)
                    .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
                if (visible.length > 0) {
                    setActiveId(visible[0].target.id);
                }
            },
            {
                rootMargin: "-80px 0px -65% 0px",
                threshold: 0,
            }
        );

        headings.forEach(({ id }) => {
            const el = document.getElementById(id);
            if (el) observer.observe(el);
        });

        observerRef.current = observer;

        return () => observer.disconnect();
    }, [headings]);

    if (headings.length === 0) return null;

    function handleClick(id) {
        const el = document.getElementById(id);
        if (el) {
            // Offset extra para não ficar sob o header fixo
            const top = el.getBoundingClientRect().top + window.scrollY - 90;
            window.scrollTo({ top, behavior: "smooth" });
        }
    }

    return (
        <nav className={styles.toc} aria-label="Índice do artigo">
            <p className={styles.tocHeader}>
                <span className={styles.tocIcon}>📋</span>
                Neste artigo
            </p>
            <ul className={styles.tocList}>
                {headings.map(({ id, text, level }) => (
                    <li key={id} className={styles.tocItem}>
                        <button
                            type="button"
                            onClick={() => handleClick(id)}
                            className={[
                                styles.tocLink,
                                level === 3 ? styles.tocLinkSub : "",
                                activeId === id ? styles.tocLinkActive : "",
                            ]
                                .filter(Boolean)
                                .join(" ")}
                        >
                            {text}
                        </button>
                    </li>
                ))}
            </ul>
        </nav>
    );
}
